import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import RenderIf from '../../render-if'
import StyledContainer from './styled/index'
import StyledRadio from './styled/radio'

const InputRadio = forwardRef(function (props, ref) {
  const {
    className,
    style,
    value,
    name,
    label,
    size = 'md',
    // 状态
    defaultChecked,
    disabled,
    readonly,
    // 事件
    onChange,
    ...otherProps
  } = props
  return (
    <StyledContainer
      className={clsx('cursor-pointer font-size-sm', className)}
      style={style}
      ref={ref}
    >
      <StyledRadio
        id={`radio-${value}-${name}`}
        type="radio"
        name={name}
        className="form-radio"
        style={style}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        disabled={disabled}
        size={size}
        readonly={readonly}
        {...otherProps}
      />
      <RenderIf isTrue={label}>
        <span>{label}</span>
      </RenderIf>
    </StyledContainer>
  )
})

InputRadio.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape(PropTypes.object),
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
}

InputRadio.defaultProps = {
  className: undefined,
  style: {},
  name: undefined,
  value: undefined,
  label: undefined,
  size: 'md',
  defaultChecked: false,
  disabled: false,
  readonly: false,
  onChange: undefined,
}

export default InputRadio
